#import "./TeamFields.graphql"

mutation UpdateTeam($id: ID!, $name: String, $archived: Boolean) {
  updateTeam(input: { id: $id, name: $name, archived: $archived }) {
    team {
      ...TeamFields
    }
  }
}
